import { observer } from 'mobx-react-lite';
import { REWARD, RewardType } from '../../../game/rewardedManager';
import { GreenButton } from '../Reusable/GreenButton';
import { MinimPopup } from './Popups';
import { IMAGES } from '../../../game/data/images';
import { DATA } from '../../../game/data';
import { POPUP } from '../../../game/popupManager';
import { CrazySDK } from '../../../crazySDK';
import { COLORS } from '../../../game/data/colors';
import { formatNumber } from '../../../game/helpers';

export const RewardPopup: React.FC = observer(() => {
  const onActivateClick = () => {
    DATA.setIsVideoPlaying(true);
    const callbacks = {
      adFinished: () => {
        DATA.setIsVideoPlaying(false);
        REWARD.collectReward();
      },
      adError: (error: any) => {
        DATA.setIsVideoPlaying(false);
        REWARD.hidePopup();
        POPUP.showRewardedVideoErrorPopup();
        console.log('Error midgame ad', error);
      },
      adStarted: () => {},
    };
    CrazySDK.ad.requestAd('rewarded', callbacks);
  };

  if (!REWARD.rewardedPopup) {
    return null;
  }

  const reward = REWARD.rewardedPopup.type;

  let text = <>{REWARD.rewardedPopup.text}</>;

  if (REWARD.rewardedPopup.type === 'money') {
    text = (
      <>
        An investor is ready to invest{' '}
        <b>
          <span style={{ color: COLORS.green_500 }}>$</span>
          {formatNumber(REWARD.rewardedPopup.ammount!)}
        </b>{' '}
        in your airline!
      </>
    );
  }

  return (
    <MinimPopup>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div>{text}</div>
        <div style={{ flex: 1 }}></div>
        <GreenButton
          style={{
            fontSize: '1rem',
            display: 'flex',
            alignItems: 'center',
          }}
          onClick={() => onActivateClick()}
        >
          <img src={IMAGES.ICONS.video} style={{ height: '1.2rem', marginRight: 4 }} />
          ACTIVATE
        </GreenButton>
      </div>
    </MinimPopup>
  );
});
